import "./Ring.scss";

export function Ring(props) {
    return (
        <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
    )
}